<div class="form-thanks-message" [ngClass]="{ 'form-thanks-message--modal': type === 'modal' }">
  <app-icon [icon]="'check-circle'" [color]="'primary'" [width]="48"></app-icon>
  <div class="form-thanks-message__main">
    <div class="form-thanks-message__content">
      <app-title [tag]="'h1'" [tag-class]="type === 'modal' ? 'h4' : 'h3'">{{ title ?? 'forms.thanks.title' | translate }}</app-title>
      <app-paragraph>{{ description ?? ('forms.thanks.description' | translate) }}</app-paragraph>
    </div>
    <ng-content></ng-content>
  </div>
</div>
